import React from 'react';

const TestComponent = () => {
  console.log('🧪 TestComponent is rendering');
  
  return (
    <div className="min-h-screen bg-blue-500 flex items-center justify-center">
      <div className="bg-white p-8 rounded-lg shadow-lg">
        <h1 className="text-2xl font-bold text-blue-600">Test Component</h1>
        <p className="text-gray-600 mt-2">This is a test component to verify routing works.</p>
      </div>
    </div>
  );
};

export default TestComponent;